class PmdCartDrawerFoot extends HTMLElement {
  /**
   * @param {{ total_price?: number, currency?: string }} cart
   */
  updateFromCart(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    const thresholdCents = Number(this.dataset.thresholdCents);
    const paidShippingCents = Number(this.dataset.paidCents);
    const freeShippingLabel = this.dataset.freeLabel || '';
    const shippingIsFree = cart.total_price >= thresholdCents;
    const currency = cart.currency || 'USD';

    const subtotalElement = this.querySelector('[data-cart-subtotal]');
    if (subtotalElement instanceof HTMLElement) {
      subtotalElement.textContent = this.#formatMoney(cart.total_price, currency);
    }

    const badgeElement = this.querySelector('[data-shipping-badge]');
    if (badgeElement instanceof HTMLElement) {
      badgeElement.hidden = !shippingIsFree;
    }

    const valueElement = this.querySelector('[data-shipping-value]');
    if (valueElement instanceof HTMLElement) {
      valueElement.textContent = shippingIsFree
        ? freeShippingLabel
        : `+${this.#formatMoney(paidShippingCents, currency)}`;
    }

    const totalElement = this.querySelector('[data-estimated-total]');
    if (totalElement instanceof HTMLElement) {
      const estimatedTotal = cart.total_price + (shippingIsFree ? 0 : paidShippingCents);
      totalElement.textContent = this.#formatMoney(estimatedTotal, currency);
    }
  }

  /**
   * @param {number} cents
   * @param {string} currency
   */
  #formatMoney(cents, currency) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currency,
    });
  }
}

if (!customElements.get('pmd-cart-drawer-foot')) {
  customElements.define('pmd-cart-drawer-foot', PmdCartDrawerFoot);
}
